import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MpError } from '@mp-core/interfaces/mp-error';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private error = new Subject<MpError>();

  all(): Observable<MpError> {
    return this.error.asObservable();
  }

  only(code: number): Observable<MpError> {
    return this.error.asObservable()
      .pipe(filter((err) => err.code === code));
  }

  emit(error: MpError) {
    this.error.next(error);
  }
}
